import { render, staticRenderFns } from "./BtnRemoverFormacaoCarga.vue?vue&type=template&id=27686b4e&"
import script from "./BtnRemoverFormacaoCarga.vue?vue&type=script&lang=js&"
export * from "./BtnRemoverFormacaoCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports